export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',

  AUTH = '/authorization',

  INVITATION = '/invitation',

  CREATE_ORG = '/create-org',
}

// 白名单路由，即该路由不会经过全局路由守卫的逻辑
export const whiteNameList: string[] = [
  'Authorization',
  'BatchAuthRedirect',
  'BrowserExtensionAuthorization',
  'BrowserExtensionGuide',
  'Invitation',
  'CreateOrg',
  'InvalidOrg',
  'WxLogin',
  'EditorRedirect',
  'PackageTrial',
  'PackagePersonal',
];
